<template>
  <form>
    <div class="image-container mb-3" v-if="previewPath">
      <img :src="previewPath" alt="Uploaded Image Preview" />
    </div>
    <div class="form-group">
      <div ref="dashboardContainer"></div>
    </div>
    <!-- <v-btn :disabled="disabled" @click.prevent="confirmUpload" class="btn btn-primary btn-block mb-2">Confirm upload</v-btn> -->
  </form>
</template>

<script>
import Uppy from "@uppy/core";
import { AwsS3Multipart, uploadedKey } from "@/utils/uppyS3Multipart";
// import XHRUpload from "@uppy/xhr-upload";
// import S3Upload from "@uppy/aws-s3-multipart";
// import companion from "@uppy/companion";
let uuid = require("uuid");
import Dashboard from "@uppy/dashboard";
// import Form from "@uppy/form";
import Russian from "@uppy/locales/lib/ru_RU";
import English from "@uppy/locales/lib/en_US";
import { s3PublicUrl } from "@/utils/s3PublicUrl";

import "@uppy/core/css/style.css";
import "@uppy/dashboard/css/style.css";

export default {
  props: {
    maxFileSizeInBytes: {
      type: Number,
      required: true,
    },
    width: {
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    editedClient: {
      type: Object,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payload: null,
      previewPath: null,
      disabled: true,
    };
  },
  mounted() {
    this.instantiateUppy();
  },
  beforeDestroy() {
    this.uppy.destroy();
  },
  methods: {
    instantiateUppy() {
      let self = this;
      this.uppy = new Uppy({
        debug: false,
        locale: this.$i18n.locale === "ru" ? Russian : English,
        autoProceed: true,
        allowMultipleUploadBatches: true,
        width: '100%',
        height: this.height,
        restrictions: {
          maxFileSize: this.maxFileSizeInBytes,
          minNumberOfFiles: 1,
          maxNumberOfFiles: 10,
          // allowedFileTypes: [
          //   "image/*",
          //   ".heic",
          //   ".heif",
          //   "application/msword",
          //   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          //   "application/pdf",
          //   "application/vnd.ms-excel",
          //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          //   "application/vnd.ms-powerpoint",
          //   "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          //   "application/vnd.oasis.opendocument.text",
          //   "application/vnd.oasis.opendocument.spreadsheet",
          //   "application/vnd.oasis.opendocument.presentation",
          //   "application/vnd.oasis.opendocument.graphics",
          //   "application/vnd.oasis.opendocument.chart",
          //   "application/vnd.oasis.opendocument.database",
          //   "application/vnd.oasis.opendocument.formula",
          //   "application/vnd.oasis.opendocument.image",
          // ],
        },
      })
        .use(Dashboard, {
          hideUploadButton: true,
          theme: this.theme,
          inline: true,
          width: this.width,
          height: this.height,
          target: this.$refs.dashboardContainer,
          browserBackButtonClose: true,
          proudlyDisplayPoweredByUppy: false,
        })
        .use(AwsS3Multipart, {
          limit: 5,
          companionEndpoint: `${this.$store.getters.getApiUrl}/contractor_files`, // FT-018
        });
      this.uppy.on("complete", (event) => {
        event.successful.forEach((element) => {
          if (element !== undefined) {
            console.log(uploadedKey(element));
            self.axios
              .post(
                `/api/v1/contractor_files/${self.$route.params.id}`,
                {
                  contractor_files: {
                    name: uploadedKey(element),
                    url: s3PublicUrl(uploadedKey(element)),
                  },
                },
                {
                  headers: {
                    Authorization: self.$store.getters.getAuthToken,
                  },
                }
              )
              .catch((error) => {
                this.setError(error, this.$t("errors.error"));
              });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.image-container {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
}

.image-container>img {
  width: inherit;
  height: inherit;
}
</style>
